import { convertExcelDataToJSONRows } from '../excel';
import { focExcelSheetNamesMap, schemeTypeMap } from './constantsAndUtils';

const isSixDigitNumber = (val) =>
  typeof val === 'number' && val.toString().length === 6;

function flattenExcelSheets(sheets, errors, focType) {
  const result = [];
  const obj = {
    vanNo: [],
    focModel: [],
    slabs: [],
    capping: {},
    quantity: 0,
    focUnit: 0,
  };
  for (let s = sheets.length - 1; s >= 0; s--) {
    const { name: sheet, data } = sheets[s];
    for (let i = 1; i < data.length; i++) {
      const row = data[i];
      if (!row || row.every((cell) => cell === '')) continue;
      switch (sheet) {
        case focExcelSheetNamesMap.applicableModel:
          //Only add values that are 6 digit numbers
          if (isSixDigitNumber(row[0])) {
            obj.applicableModel.push(row[0]);
          } else {
            errors.add('applicableModel');
          }
          break;
        case focExcelSheetNamesMap.focModel:
          // Only add values that are 6 digit numbers
          obj.focModel = row.filter((cell) => isSixDigitNumber(cell));
          break;
        case focExcelSheetNamesMap.slabs:
          // if lower limit is present, there should be a higher limit and foc unit
          if (row[0] !== '' && row[1] !== '' && row[2] !== '') {
            obj.slabs.push({
              lowerLimit: row[0],
              higherLimit: row[1],
              focUnit: row[2],
            });
          }
          break;
        case focExcelSheetNamesMap.capping:
          obj.capping['applicableModelCapping'] = row[0] || 0;
          obj.capping['focUnitCapping'] = row[1] || 0;
          break;
        case focExcelSheetNamesMap.incrementalQuantity:
          // quantity and foc unit should be present
          console.log(row[0], row[1], 'incrementalQuantity');
          if (row[0] && row[1]) {
            obj.quantity = row[0];
            obj.focUnit = row[1];
          } else {
            errors.add('incrementalQuantity');
          }
          break;
        case focExcelSheetNamesMap.applicableAndFocModel:
          // Only add values that are 6 digit numbers and both should be present
          if (
            isSixDigitNumber(row[0]) &&
            row.slice(1).filter((cell) => isSixDigitNumber(cell)).length > 0
          ) {
            const product = {
              ...obj,
              vanNo: [row[0]],
              focModel: row.slice(1).filter((cell) => isSixDigitNumber(cell)),
            };
            result.push(product);
          } else {
            errors.add('applicableAndFocModel');
          }

          break;
        default:
          break;
      }
    }
  }
  console.log(focType, 'focType');
  if (focType === 'Many-One') {
    result.push(obj);
  }
  return result;
}

export const parseUploadedExcelData = (file, formInput) => {
  console.log('file', file);
  let allColumns = [];
  let allRows = [];
  let arrData = [];
  const errors = new Set();
  let validProducts = [];
  let showCappingType = false;
  let addTarget = false;
  switch (formInput.type?.[0]) {
    case schemeTypeMap.foc:
      let products = [];
      switch (formInput.focType?.[0]) {
        case 'Many-One':
        case 'Many-Many':
          products = flattenExcelSheets(file, errors, formInput.focType?.[0]);
          console.log('products', products);
          break;
        case 'One-One':
        case 'One-Many':
          const data = file[0].data;
          allColumns = data[0];
          allRows = data.slice(1);
          arrData = convertExcelDataToJSONRows(allColumns, allRows);
          const requiredFields = [
            'vanNo',
            'freebieVan',
            'mainProductQuantity',
            'freebieQuantity',
          ];
          arrData.forEach((row) => {
            // Validate required fields
            if (['One-One', 'One-Many'].includes(formInput.focType?.[0])) {
              requiredFields.forEach((field) => {
                if (!row[field]) {
                  errors.add(field);
                }
              });
            }

            // Build slabs dynamically
            const slabs = {};
            Object.keys(row).forEach((key) => {
              const match = key.match(/^slab(\d+)$/);
              if (match) {
                const index = match[1];
                const slabName = row[key];
                const quantityKey = `slab${index}Quantity`;
                const quantityValue = row[quantityKey];

                if (slabName) {
                  if (!quantityValue) {
                    errors.add(quantityKey);
                  }
                  slabs[slabName] = quantityValue;
                }
              }
            });
            const product = {
              vanNo: [row.vanNo?.toString()],
              mainProductQuantity: row.mainProductQuantity,
              freebieQuantity: row.freebieQuantity,
              slabs,
              vanNoCapping: row.vanNoCapping || 0,
              freebieVanCapping: row.freebieVanCapping || 0,
              freebieVan: row.freebieVan,
            };

            products.push(product);
          });

          products.forEach((item) => {
            item.freebieVan = item.freebieVan
              ?.toString()
              .split('/')
              .map((s) => s.trim());
          });
      }
      console.log(products);
      console.log(errors);
      if (errors.size === 0) {
        validProducts = products;
      }
      break;
    default:
      const data = file[0].data;
      allColumns = data[0];
      allRows = data.slice(1);
      arrData = convertExcelDataToJSONRows(allColumns, allRows);
      arrData.forEach((item) => {
        const isValidPayout = (val) => !isNaN(Number(val));
        const isValidValuationType = (val) =>
          typeof val === 'string' &&
          ['value', 'percentage'].includes(val.toLowerCase());
        if (!item.productName) errors.add('product');
        if (!item.vanNo || !isSixDigitNumber(item.vanNo)) {
          errors.add('vanNo');
        }
        if (!item.valuationType || !isValidValuationType(item.valuationType)) {
          errors.add('valuationType');
        }
        if (!item.payout || !isValidPayout(item.payout)) {
          errors.add('payout');
        }
        if (formInput.type?.[0] === schemeTypeMap.upgradeOffer) {
          if (!item.brandAmount) errors.add('brandAmount');
        }

        validProducts.push({
          productName: [item.productName],
          vanNo: item.vanNo,
          valuationType: [item.valuationType],
          payout: item.payout,
          cappingType: [item.cappingType],
          cappingQuantity: item.cappingQuantity,
          vsAmount: item.vsAmount || 0,
          brandAmount: item.brandAmount,
          target: item.target || 0,
          quantity: item.quantity,
          freebieVan: item.freebieVan?.toString()?.split(','),
          freebieQuantity: item.freebieQuantity?.toString()?.split(','),
          payoutBasis: [item.payoutBasis],
        });
      });
      showCappingType = arrData.some(
        (item) => item.cappingType || item.cappingQuantity
      );
      addTarget = arrData.some((item) => item.target);
      break;
  }
  return {
    validProducts,
    showCappingType,
    addTarget,
    errors,
  };
};
